import { guid } from 'services/util';
import {
  commandsToFilterRows,
  filterRowsToCommands,
  optimizeCommands,
} from './commands';

export const nextPersonalizationSetName = (existing = []) =>
  `Personalization ${existing.length + 1}`;

export const createEmptySet = (existing = []) => ({
  clientId: guid(),
  name: nextPersonalizationSetName(existing),
  order: existing.length,
  filterRows: commandsToFilterRows(undefined),
  layoutMappingIds: [],
  contentMappingIds: [],
});

export const apiSetsToDrafts = (sets = []) => {
  const drafts = [];
  sets.forEach((set, index) => {
    drafts.push({
      clientId: set.id || guid(),
      id: set.id,
      name: set.name?.trim() || nextPersonalizationSetName(drafts),
      order: set.order ?? index,
      filterRows: commandsToFilterRows(set.commands),
      layoutMappingIds: set.layoutMappingIds || [],
      contentMappingIds: set.contentMappingIds || [],
    });
  });
  return drafts;
};

export const draftsToApiSets = (drafts, dynamic) =>
  drafts.map((draft, index) => ({
    id: draft.id,
    name: draft.name,
    order: draft.order ?? index,
    commands: optimizeCommands(filterRowsToCommands(draft.filterRows)),
    layoutMappingIds: dynamic ? [] : draft.layoutMappingIds,
    contentMappingIds: dynamic ? draft.contentMappingIds : [],
  }));

export const pruneSetAssetIds = (sets, allowedIds, dynamic) => {
  const allowed = allowedIds instanceof Set ? allowedIds : new Set(allowedIds);
  const key = dynamic ? 'contentMappingIds' : 'layoutMappingIds';
  return sets.map((set) => ({
    ...set,
    [key]: set[key].filter((id) => allowed.has(id)),
  }));
};
